export default "__VITE_ASSET__CUcTCnAg__"